// ÐÑÐ´Ð° Ð¿Ð¾ÑÑÐ°Ð²Ð¸ÑÑ ÐºÐ°ÑÑÐ¾ÑÐºÑ-Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÑ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÐµÐ»ÑÐ½Ð¾ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐµÐ½Ð½Ð¾Ð³Ð¾ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ°.
//
// Ð§Ð¸ÑÑÐ°Ñ ÑÑÐ½ÐºÑÐ¸Ñ Ð±ÐµÐ· DOM: Ð½Ð° Ð²ÑÐ¾Ð´ â Ð¿ÑÑÐ¼Ð¾ÑÐ³Ð¾Ð»ÑÐ½Ð¸Ðº ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ°, ÑÐ°Ð·Ð¼ÐµÑ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ Ð¸
// ÑÐ°Ð·Ð¼ÐµÑ Ð¾ÐºÐ½Ð°, Ð½Ð° Ð²ÑÑÐ¾Ð´Ðµ â ÐºÐ¾Ð¾ÑÐ´Ð¸Ð½Ð°ÑÑ. Ð¢Ð°Ðº ÐµÑ Ð²Ð¸Ð´Ð½Ð¾ Ð² ÑÐµÑÑÐµ Ð¸ Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾
// Ð¿Ð¾Ð´Ð±Ð¸ÑÐ°ÑÑ Ð¾ÑÑÑÑÐ¿Ñ Ð²Ð¶Ð¸Ð²ÑÑ.

const GAP = 12; // Ð·Ð°Ð·Ð¾Ñ Ð¼ÐµÐ¶Ð´Ñ ÑÐ»ÐµÐ¼ÐµÐ½ÑÐ¾Ð¼ Ð¸ ÐºÐ°ÑÑÐ¾ÑÐºÐ¾Ð¹
const EDGE = 12; // Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½ÑÐ¹ Ð¾ÑÑÑÑÐ¿ Ð¾Ñ ÐºÑÐ°Ñ ÑÐºÑÐ°Ð½Ð°

const place = (placement, target, card) => {
  switch (placement) {
    case 'top':
      return { top: target.top - card.height - GAP, left: target.left + target.width / 2 - card.width / 2 };
    case 'left':
      return { top: target.top + target.height / 2 - card.height / 2, left: target.left - card.width - GAP };
    case 'right':
      return { top: target.top + target.height / 2 - card.height / 2, left: target.right + GAP };
    case 'bottom':
    default:
      return { top: target.bottom + GAP, left: target.left + target.width / 2 - card.width / 2 };
  }
};

const fits = (pos, card, viewport) =>
  pos.top >= EDGE &&
  pos.left >= EDGE &&
  pos.top + card.height <= viewport.height - EDGE &&
  pos.left + card.width <= viewport.width - EDGE;

const clamp = (pos, card, viewport) => ({
  top: Math.min(Math.max(pos.top, EDGE), Math.max(EDGE, viewport.height - card.height - EDGE)),
  left: Math.min(Math.max(pos.left, EDGE), Math.max(EDGE, viewport.width - card.width - EDGE)),
});

// Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð¿ÑÐ¾Ð±ÑÐµÐ¼ ÑÑÐ¾ÑÐ¾Ð½Ñ Ð¸Ð· Ð¾Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ ÑÐ°Ð³Ð°, Ð·Ð°ÑÐµÐ¼ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÐµ Ð¿Ð¾ ÐºÑÑÐ³Ñ. ÐÑÐ»Ð¸ Ð½Ðµ
// Ð²Ð»ÐµÐ·Ð°ÐµÑ Ð½Ð¸ÐºÑÐ´Ð° (ÑÐ·ÐºÐ¸Ð¹ ÑÐºÑÐ°Ð½), Ð¿ÑÐ¸Ð¶Ð¸Ð¼Ð°ÐµÐ¼ Ðº ÐºÑÐ°Ñ â Ð»ÑÑÑÐµ ÑÐ°Ðº, ÑÐµÐ¼ Ð·Ð° ÑÐºÑÐ°Ð½Ð¾Ð¼.
export const computeCardPosition = (target, card, viewport, placement = 'bottom') => {
  const order = [placement, 'bottom', 'top', 'right', 'left'];

  for (let i = 0; i < order.length; i += 1) {
    const pos = place(order[i], target, card);
    if (fits(pos, card, viewport)) return pos;
  }

  return clamp(place(placement, target, card), card, viewport);
};

export default computeCardPosition;
